import { classify, camelize, singularize } from 'inflected'

export default class Base {
  constructor (model, name, options = {}) {
    this.model = model
    this.name = name

    this.primaryKey = options.primaryKey || 'id'
    this.namespace = options.namespace || window
    this.modelName = options.model || classify(singularize(name))

    this.__register()
    this.__bind()
  }

  getAssociation (model, name) {
    return model.prototype._associations[name]
  }

  associatedModel () {
    return this.namespace[this.modelName]
  }

  __register () {
    this.model.prototype._associations ||= {}
    this.model.prototype._associations[this.name] = this
  }

  __bind () {
    const association = this

    this.model.prototype[`get${camelize(this.name)}`] = function () {
      return association.getResult(this)
    }
  }
}
